<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-table [rows]="rows" [columns]="columns" [batch]="true" [actions]="tableActions" (changeBatch)="onChangeBatch($event)" (action)="onAction($event)">
</app-table>

<div *ngIf="rows.length" class="d-flex justify-content-between align-items-center my-15 has-pagination">
  <div class="d-flex align-items-center justify-content-end pagination-right">
    <span class="pagination-count">Showing {{ rows.length }} of {{ totalCount }} results</span>
  </div>
</div>

<ng-template #formModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ countryModel.id ? 'Edit' : 'Create' }} country</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-country-form [model]="countryModel" (onAfterSave)="onAfterSave()" [backButtonShow]="false"></app-country-form>
  </div>
</ng-template>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>
